import React, { useContext, useEffect, useState } from 'react';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from './CheckoutForm';
import axios from 'axios';
import "./Payment.css"
import Header from '../Header/Header';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft} from "@fortawesome/free-solid-svg-icons";




const stripePromise = loadStripe('pk_test_51NXnKeJPEwpnbb9mdRlg4ziXKejnTShfv8d3a3r6JEAFkzvpgxEmPN6ItB29R8dFUBLfvq96XDqapUh1AFRhZKWG00KmfKG433');

const Payment = () => {
    const [clientSecret, setClientSecret] = useState("");
    const [eventLoading,setEventLoading] = useState(true);
    const [event,setEvent] = useState();
    const {id,selectedQuantity} = useParams();
    const navigate = useNavigate();
   

    const quantity = parseInt(selectedQuantity);
  

    useEffect(()=> {
      const fetchEvent = async () => {
          try {
              const res = await axios.get(`https://event-finder12.onrender.com/events/getevent/${id}`); 
              setEvent(res.data);
              console.log(res.data)
              setEventLoading(false);
  
          } catch (error) {
              console.error("Error fetching event:", error);
          }
      };
      
      fetchEvent();
  },[id]);



    useEffect(() => {
      axios({
        method: 'post',
        url: 'https://event-finder12.onrender.com/create-payment-intent',
        headers: { 'Content-Type': 'application/json' },
        data: { amount: 1999 } // Replace this with the actual total amount
    })
    .then((response) => {
        setClientSecret(response.data.clientSecret);
    })
    .catch((error) => {
        console.error("Failed to create payment intent: ", error);
        // handle the error in your UI as needed
    });
    }, []);


    const appearance = {
      theme: 'flat',
    };
    const options = {
      clientSecret,
      appearance,
    };

  console.log(quantity)



    const handleGoBack = () => {
      navigate(`/event/${id}`);
    }

    return (
      
      <div className='outer-container-payment'>
        <div className='header-container-payment'>
        <Header/>
        </div>

        {!eventLoading ? (<>  <div className='payment-body-container'>
          <div className='payment-details-aside'>
            <div style={{display:"flex"}}> <FontAwesomeIcon onClick={handleGoBack} icon={faArrowLeft} className='arrow-back-icon backArrow' /> <span style={{marginLeft:"0.4em"}}>Event Details</span></div>
         
              <p>Pay {event.createdBy.displayName}</p>
              <h1>£ {event.ticketPrice * quantity}</h1>
              <div className='ticket-breakdown'>
                <h3>{event.title}</h3>
                <div className='ticket-breakdown-row'>
                  <h5>Qty {quantity}</h5>
                  <h5>£ {event.ticketPrice} / ticket</h5>
                </div>
              </div>
          </div>
        <div className="payment-form">
            {clientSecret && (
                <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm event={event} quantity={selectedQuantity}/>
                </Elements>
            )}
        </div>
        </div></>):<></>}
      
       
      </div>
        
    );
}

export default Payment;
